import getProductLineLetter from '../../utils/api/getProductLineLetter';
import { apiModes } from '../../utils/constants';
import { useApiHost, useAppName, useLanguage, usePageState, useUserOrDefaultProvince, } from '../../utils/sitecoreContext';
import { useGetProtectionQuery } from '../apis/hondaRestApi';
import { useAppSelector } from '../utils';
import { selectCurrentBodyType } from '../reducers/vehicles';
import { PaymentMethod, selectPrimaryCalculatorLeaseAnnualKmAllowance, selectPrimaryCalculatorTermAndRate, } from '../reducers/financialCalculators';
const useFetchLegacyProtection = (method, vehicleType) => {
    const appName = useAppName();
    const hondaRestApi = useApiHost();
    const language = useLanguage();
    const pageState = usePageState();
    const productLineLetter = vehicleType
        ? getProductLineLetter.get(appName)[vehicleType]
        : getProductLineLetter.get(appName);
    const provinceCode = useUserOrDefaultProvince();
    const bodyStyle = useAppSelector(selectCurrentBodyType);
    const term = useAppSelector(selectPrimaryCalculatorTermAndRate);
    const kmAllowance = useAppSelector(selectPrimaryCalculatorLeaseAnnualKmAllowance);
    const baseParams = `provinceCode=${provinceCode}&bodyStyle=${bodyStyle}&AcceptLanguage=${language}`;
    let additionalParams = '';
    if (method === PaymentMethod.finance) {
        additionalParams = `&term=${term}`;
    }
    else if (method === PaymentMethod.lease) {
        additionalParams = `&term=${term}&kmAllowance=${kmAllowance}`;
    }
    const url = `https://${hondaRestApi}/owner-program/${productLineLetter}/${apiModes[pageState]}/ownerprograms/method/${method}?${baseParams}${additionalParams}`;
    const shouldSkipRequest = !method ||
        !productLineLetter ||
        !hondaRestApi ||
        !provinceCode ||
        !bodyStyle ||
        !language ||
        (method === PaymentMethod.finance && !term) ||
        (method === PaymentMethod.lease && !term && !kmAllowance);
    return useGetProtectionQuery({ url }, {
        skip: shouldSkipRequest,
    });
};
export default useFetchLegacyProtection;
